import { Field } from 'redux-form';
import { SelectField } from 'iqvia-shared/components';
import React from 'react';

const DictObjectField = ({ name, label, values, onChange, readonlyForm }) => {
  const options = Object.getOwnPropertyNames(values).map(x => ({
    value: x,
    label: values[x],
  }));

  return (
    <Field
      name={`${name}`}
      component={SelectField}
      items={options}
      label={label}
      disabled={readonlyForm}
      onChange={(_, value) => onChange(value)}
    />
  );
};

DictObjectField.displayName = 'DictObjectField';

export default DictObjectField;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/PathObjectFields/DictObjectField.js